module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAANlBMVEUAAAAwMDAzMzMyMjIzMzMwMDAyMjIzMzMyMjIyMjIzMzMzMzMyMjIzMzMxMTEyMjIwMDAzMzM+M0peAAAAEXRSTlMAMPDvzxBgoJ/gsK+Qb0+AIHtMkJUAAACSSURBVDjLddNLDoMwDEVRkwZavu3b/2YbkKI3uHEmtnTuyIKIuM45hm8+l3sc0msaepX2NqVe0KW2rC7opW1T6QVdV4wK+xKBAo4CzsLOAo4CjsKeFPakgKOAo7Dz7U8wpf6RfI7cXdBR0N/9YJn7pJmjgKOAo4C7gLOgszjsLGrb7Cj6r2dHsd6zlm/yeWzbL/4e4xMWSV9qpgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-address-close.png
// module id = IssX
// module chunks = 1